// extracted by mini-css-extract-plugin
export default {"item":"NextPage_item__6RfHy","link":"NextPage_link__fZJD7"};